/** Client + proxy caps — prevents multi-million-row flow overload. */
export const FLOW_DATASET_DEFAULT_LIMIT = 100;
export const FLOW_DATASET_MAX_LIMIT = 1000;
export const FLOW_OPPORTUNITIES_DEFAULT_LIMIT = 100;
export const FLOW_OPPORTUNITIES_MAX_LIMIT = 1000;

export function clampFlowRowLimit(
  requested: number | undefined,
  fallback = FLOW_DATASET_DEFAULT_LIMIT,
  max = FLOW_DATASET_MAX_LIMIT,
): number {
  const n = Number(requested);
  const base = Number.isFinite(n) && n > 0 ? Math.floor(n) : fallback;
  return Math.max(1, Math.min(max, base));
}
